export interface MotionFxConfig {
  cameraBobPx: number;
  cameraLeanPx: number;
  landingSquash: number;
  landingKickPx: number;
  speedStreaks: boolean;
  runDust: boolean;
  leafBurst: boolean;
  hitShake: boolean;
}

/** Hills/forest stay still; birds may breathe a few pixels so they do not look glued on. */
export const SKYLINE_DRIFT_PX = {
  hills: 0,
  forest: 0,
  birds: 4,
  birds2: 3,
} as const;

/** Ambient leaf flurry along the trail edges. */
export const LEAF_FLURRY = {
  intervalMs: 2400,
  speedCutMs: 400,
  scaleMul: 1.12,
} as const;

export const DEFAULT_MOTION_FX: MotionFxConfig = {
  cameraBobPx: 0,
  cameraLeanPx: 0,
  landingSquash: 0.94,
  landingKickPx: 0,
  speedStreaks: false,
  runDust: true,
  leafBurst: true,
  hitShake: true,
};

export function motionFx(): MotionFxConfig {
  return DEFAULT_MOTION_FX;
}
